import { State } from 'app/gamma/src/modules/types';
import { TeamType } from 'app/gamma/src/modules/state/models/teams';
import { ProductKeys } from '@atlassiansox/product-store-react';

export const getActiveOverlay = (state: State): string | null => {
  const { overlayType } = state.ui.overlay;
  return overlayType;
};

export const getTeamType = (state: State): TeamType | null => {
  const { teamType } = state.ui.overlay;
  return teamType;
};

export const getProductKey = (state: State): ProductKeys | null => {
  const { productKey } = state.ui.overlay;
  return productKey;
};
